import React from 'react';
import {
  FaFacebookF,
  FaWhatsapp,
  FaInstagram,
  FaYoutube,
  FaLinkedinIn,
  FaPinterestP,
} from 'react-icons/fa';
import './Footer.css';
import Logo from '../assets/Nandanam_logo.png';// Replace this with your actual logo

const socialLinks = [
  { icon: <FaFacebookF />, url: '#', name: 'Facebook', className: 'social-facebook' },
  { icon: <FaWhatsapp />, url: 'https://wa.me/919000000000', name: 'WhatsApp', className: 'social-whatsapp' },
  { icon: <FaInstagram />, url: '#', name: 'Instagram', className: 'social-instagram' },
  { icon: <FaYoutube />, url: '#', name: 'YouTube', className: 'social-youtube' },
  { icon: <FaLinkedinIn />, url: '#', name: 'LinkedIn', className: 'social-linkedin' },
  { icon: <FaPinterestP />, url: '#', name: 'Pinterest', className: 'social-pinterest' },
];

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Logo and Social Icons */}
          <div className="footer-column">
            <img src={Logo} alt="Namdanam Infra Logo" className="footer-logo" />
            <div className="social-icons">
              {socialLinks.map(({ icon, url, name, className }) => (
                <a
                  key={name}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`social-icon ${className}`}
                  aria-label={name}
                >
                  {icon}
                </a>
              ))}
            </div>
          </div>

          {/* About Namdanam Infra */}
          <div className="footer-column foort_about">
            <h5>About Namdanam Infra</h5>
            <p>
              Namdanam Infra is a trusted name in real estate and infrastructure development. 
              We specialize in open plots, premium land investments, and real estate consultancy 
              across South India. Our commitment is to provide secure and rewarding property investments.
              <br />
              <strong>Our Motto:</strong>{' '}
              <span style={{ color: '#ea1b24' }}>
                "Building Your Dreams, Brick by Brick."
              </span>
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-column footer_linking">
            <h5>Quick Links</h5>
            <ul className="footer-links">
              <li><a href="/">Home</a></li>
              <li><a href="/about">About</a></li>
              <li><a href="/projects">Projects</a></li>
              <li><a href="/contact">Contact Us</a></li>
              <li><a href="/gallery">Gallery</a></li>
              <li><a href="/invest">Invest With Us</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-column">
            <h5>Contact</h5>
            <p>Email: <a href="mailto:info@namdanaminfra.com" style={{ color: '#2ba1dc' }}>info@namdanaminfra.com</a></p>
            <p>Phone: <a href="tel:+919000000000" style={{ color: '#2ba1dc' }}>+91 90000 00000</a></p>
            <p>
              1st Floor, Namdanam Towers,<br />
              Nehru Nagar, Hyderabad, Telangana, India – 500001<br />
              <span style={{ fontSize: '0.97em', color: '#aaa' }}>
                Open: Mon - Sat, 9:30 AM to 6:00 PM
              </span>
            </p>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          &copy; {new Date().getFullYear()} Namdanam Infra. All rights reserved.
        </div>
      </div>
    </footer>
  );
}

export default Footer;
